import { combineReducers } from 'redux';

import rehydrate from './rehydrate';
import global from './global';
import authentication from './authentication';
import users from './users';
import holidays from './holidays';
import vacation from './vacation';
import calendar from './calendar';
import vacations from './vacations';
import projects from './projects';
import myReports from './myreports';

const rootReducer = combineReducers({
  rehydrate,
  global,
  authentication,
  users,
  holidays,
  vacation,
  calendar,
  vacations,
  projects,
  myReports
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js